import { useToast, TOAST_DEFAULT_DURATION } from "../../hooks/use-toast"
import { resolveToastTone } from "../../lib/toastTone"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastIcon,
  ToastProgress,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  TOAST_SWIPE_DIRECTION,
} from "./toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider swipeDirection={TOAST_SWIPE_DIRECTION}>
      {toasts.map(function ({ id, title, description, action, tone, variant, duration, ...props }) {
        // Ton çağıran taraftan gelmiyorsa metinden çözülür (bkz.
        // lib/toastTone.js); böylece yüzlerce mevcut çağrı tek satır
        // değişmeden doğru rengi ve ikonu alır.
        const resolvedTone = resolveToastTone({ tone, variant, title, description });
        const resolvedDuration = duration ?? TOAST_DEFAULT_DURATION;
        return (
          <Toast key={id} tone={resolvedTone} duration={resolvedDuration} {...props}>
            <ToastIcon tone={resolvedTone} />
            <div className="bhs-toast-body">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            <div className="bhs-toast-tail">
              {action}
              <ToastClose />
            </div>
            <ToastProgress duration={resolvedDuration} />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
